import React, { useState } from 'react';

import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Button, Spinner } from '@telus-uds/components-web';
import FileDownload from 'js-file-download';
import axios from 'axios';

import { ButtonWrapper } from './css';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { apiHost, config } from '../../../utils/request';
import ConfirmationBox from '../../../design/shared/ConfirmationBox';
import { getFormattedPayload, initialFiltersValue } from '../../utils';

const ExportReport = ({ filters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { EXPORT_USERS, confirmationDialog }
  } = localizedStrings;

  const [isExporting, setIsExporting] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const handleExportReport = async (filteredUsers = false) => {
    try {
      setShowConfirmationModal(false);
      setIsExporting(true);
      const payload = filteredUsers
        ? getFormattedPayload(filters)
        : initialFiltersValue;

      const result = await axios.post(`${apiHost}/users/export`, payload, {
        ...config(),
        responseType: 'arraybuffer'
      });
      if (result) {
        FileDownload(
          _.get(result, 'data', ''),
          `users-${moment().format('YYYYMMDDHHmmss')}.xlsx`
        );
      }
    } catch (error) {
      throw error;
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <ButtonWrapper>
        <Spinner
          label="Exporting Users..."
          variant={{ size: 'small' }}
          show={isExporting}
          inline
        >
          <Button onPress={() => setShowConfirmationModal(true)}>
            {EXPORT_USERS}
          </Button>
        </Spinner>
      </ButtonWrapper>
      <ConfirmationBox
        open={showConfirmationModal}
        hideCloseButton={false}
        setOpen={setShowConfirmationModal}
        header={confirmationDialog}
        onClose={() => {
          setShowConfirmationModal(false);
        }}
      >
        <div style={{ display: 'flex', gap: '1rem' }}>
          <Button onPress={() => handleExportReport(true)}>
            Export filtered users
          </Button>
          <Button variant={{ priority: 'low' }} onPress={() => handleExportReport(false)}>
            Export all users
          </Button>
        </div>
      </ConfirmationBox>
    </>
  );
};

ExportReport.propTypes = {
  filters: PropTypes.shape({
    salesManager: PropTypes.arrayOf(PropTypes.string),
    channel: PropTypes.arrayOf(PropTypes.number),
    dealership: PropTypes.arrayOf(PropTypes.number),
    outletId: PropTypes.arrayOf(PropTypes.number),
    channelOrgCode: PropTypes.arrayOf(PropTypes.number),
    accountStatus: PropTypes.arrayOf(PropTypes.string)
  }).isRequired
};

export default ExportReport;
